import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { IEscalationStatus, IModel } from "./StatusMaster";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Toolbar } from "primereact/toolbar";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reLoad: boolean
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IEscalationStatus>, loading: boolean });
    const dt = useRef<any>(null);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
    const DateFormat = loginObj?.date_Format;

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("POEscalation/getEscalationStatusList", "GET", null, null, props.toast);
        if (response) {
            const data: IEscalationStatus[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const openEdit = (rowData: IEscalationStatus) => {
        props.setModal({ open: true, singleData: { id: rowData.id, status: rowData.status, active: rowData.active } });
    };

    const actionBodyTemplate = (rowData: IEscalationStatus) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    const openNew = () => {
        props.setModal({ open: true, singleData: { status: "", active: true } });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    useEffect(() => {
        loadTableData();
    }, [props.reLoad]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="65vh"
                value={tableData.tableData}
                header={<p>Escalation Status</p>}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="status" header="Status" />
                <Column field="active" header="Active" body={(rowData: any) => <p>{rowData.active === true ? "Active" : "In-Active"}</p>} />
                <Column field="created_By" header="Created By" />
                <Column field="created_At" header="Created At" body={(rowData: any) => safeFormatDate(rowData.created_At, "dd/MM/yyyy", DateFormat)} />
                <Column field="updated_By" header="Updated By" />
                <Column field="updated_At" header="Updated At" body={(rowData: any) => safeFormatDate(rowData.updated_At, "dd/MM/yyyy", DateFormat)} />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    );
}